import { useEffect, useState } from "react";
import { useAppSelector } from "@/redux/store";
import deliveryInfoService from "@/services/deliveryInfoService";
import { DeliveryInfo } from "@/components/product/webSizes/types";

const useDeliveryOptionsInfo = () => {
  const [deliveryInfo, setDeliveryInfo] = useState([]);
  const loyaltyTier = useAppSelector(
    state => state.myAccountReducer.loyaltyPoints.LoyaltyStatics?.tierToken
  );

  useEffect(() => {
    const getDeliveryInfo = async () => {
      try {
        const response = await deliveryInfoService.getDeliveryInfo(loyaltyTier);
        setDeliveryInfo(response);
      } catch (error) {
        console.error("Delivery info fetch got error:", error);
      }
    };
    getDeliveryInfo();
  }, [loyaltyTier]);

  return deliveryInfo as DeliveryInfo[];
};

export default useDeliveryOptionsInfo;
